var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-scroll-container",class:_vm.classes},[_c('div',{directives:[{name:"bar",rawName:"v-bar"}],staticClass:"screen-scroll-container__scroll-area"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }